// extracted by mini-css-extract-plugin
export var backProfile = "generator-start-fields-module--back-profile--x7aRR";
export var container = "generator-start-fields-module--container--d5Fby";
export var formBottom = "generator-start-fields-module--form-bottom--dCBeS";
export var formBreak = "generator-start-fields-module--form-break--TmoGB";
export var formButton = "generator-start-fields-module--form-button--N-oKq";
export var formTop = "generator-start-fields-module--form-top--gMEBL";
export var imgBox = "generator-start-fields-module--img-box--bULOk";
export var inputTop = "generator-start-fields-module--input-top--RN5fx";
export var occasionItem = "generator-start-fields-module--occasion-item--axdw5";
export var occasionWrapper = "generator-start-fields-module--occasion-wrapper--REBbv";
export var stylizationHeader = "generator-start-fields-module--stylization-header--AdV7r";
export var titleContent = "generator-start-fields-module--title-content--R8Qw2";
export var titleWrapper = "generator-start-fields-module--title-wrapper--ar7V6";